/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Inspector_Status_PartialInputs */

const en_image_inspector_status_partial = /** @type {(inputs: Image_Inspector_Status_PartialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partial metadata`)
};

const ar_image_inspector_status_partial = /** @type {(inputs: Image_Inspector_Status_PartialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بيانات وصفية جزئية`)
};

const bn_image_inspector_status_partial = /** @type {(inputs: Image_Inspector_Status_PartialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আংশিক মেটাডেটা`)
};

const de_image_inspector_status_partial = /** @type {(inputs: Image_Inspector_Status_PartialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilweise Metadaten`)
};

const es_image_inspector_status_partial = /** @type {(inputs: Image_Inspector_Status_PartialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadatos parciales`)
};

const fr_image_inspector_status_partial = /** @type {(inputs: Image_Inspector_Status_PartialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Métadonnées partielles`)
};

const pt_image_inspector_status_partial = /** @type {(inputs: Image_Inspector_Status_PartialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadados parciais`)
};

const zh_image_inspector_status_partial = /** @type {(inputs: Image_Inspector_Status_PartialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`部分元数据`)
};

const tr_image_inspector_status_partial = /** @type {(inputs: Image_Inspector_Status_PartialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kısmi meta veriler`)
};

const ru_image_inspector_status_partial = /** @type {(inputs: Image_Inspector_Status_PartialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Частичные метаданные`)
};

const pl_image_inspector_status_partial = /** @type {(inputs: Image_Inspector_Status_PartialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Częściowe metadane`)
};

/**
* | output |
* | --- |
* | "Partial metadata" |
*
* @param {Image_Inspector_Status_PartialInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_status_partial = /** @type {((inputs?: Image_Inspector_Status_PartialInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_Status_PartialInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_status_partial(inputs)
	if (locale === "bn") return bn_image_inspector_status_partial(inputs)
	if (locale === "de") return de_image_inspector_status_partial(inputs)
	if (locale === "es") return es_image_inspector_status_partial(inputs)
	if (locale === "fr") return fr_image_inspector_status_partial(inputs)
	if (locale === "pt") return pt_image_inspector_status_partial(inputs)
	if (locale === "zh") return zh_image_inspector_status_partial(inputs)
	if (locale === "tr") return tr_image_inspector_status_partial(inputs)
	if (locale === "ru") return ru_image_inspector_status_partial(inputs)
	if (locale === "pl") return pl_image_inspector_status_partial(inputs)
	return en_image_inspector_status_partial(inputs)
});